import Svg, { SvgProps } from './Svg';

export default function SkyIcon({ ...props }: SvgProps) {
  return (
    <Svg
      viewBox="0 0 483.2 483.2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <defs>
        <radialGradient
          id="skyGradient1"
          cx="665.0922"
          cy="1121.1327"
          r="1.0000044"
          gradientTransform="matrix(-183.9665 -158.8444 -158.8444 183.9665 300681.375 -100363.68)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#A273FF" />
          <stop offset="1" stopColor="#4331E9" />
        </radialGradient>
        <radialGradient
          id="skyGradient2"
          cx="659.0502"
          cy="1113.6819"
          r="1.0000043"
          gradientTransform="matrix(-38.6772 -244.3474 -244.3474 38.6772 297857.1875 118204.42)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#F7A7F9" />
          <stop offset="1" stopColor="#00DDFB" />
        </radialGradient>
        <radialGradient
          id="skyGradient3"
          cx="241.5994"
          cy="3625.6011"
          r="247.565"
          gradientTransform="matrix(1 0 0 1 0 -3384)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FFF3D0" />
          <stop offset="1" stopColor="#FFC044" />
        </radialGradient>
        <radialGradient
          id="skyGradient4"
          cx="658.4451"
          cy="1111.5996"
          r="1.0029476"
          gradientTransform="matrix(0 -247.1404 -247.1404 0 274962.53 162969.97)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#A273FF" />
          <stop offset="0.5" stopColor="#9FAEFF" />
          <stop offset="1" stopColor="#AAF2E1" />
        </radialGradient>
        <radialGradient
          id="skyGradient5"
          cx="677.8123"
          cy="1096.2599"
          r="1.0000044"
          gradientTransform="matrix(199.3928 144.8164 144.8164 -199.3928 -293665.03 120670.04)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0075FF" />
          <stop offset="1" stopColor="#00DDFB" />
        </radialGradient>
        <radialGradient
          id="skyGradient6"
          cx="685.5831"
          cy="1106.16"
          r="1.0000042"
          gradientTransform="matrix(0 247.3404 247.3404 0 -273356.66 -169330.83)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FFCD6B" />
          <stop offset="1" stopColor="#EB5EDF" />
        </radialGradient>
        <radialGradient
          id="skyGradient7"
          cx="685.5551"
          cy="1106.1655"
          r="1.0000042"
          gradientTransform="matrix(0 247.8524 247.8524 0 -273924.4 -169674.89)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#D4FAFF" />
          <stop offset="1" stopColor="#00DDFB" />
        </radialGradient>
        <radialGradient
          id="skyGradient8"
          cx="684.6171"
          cy="1111.7495"
          r="1.0000042"
          gradientTransform="matrix(-108.4337 241.589 241.589 108.4337 -194109.1 -285706.16)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FFD2B9" />
          <stop offset="0.2896" stopColor="#C99BED" />
          <stop offset="1" stopColor="#0075FF" />
        </radialGradient>
        <radialGradient
          id="skyGradient9"
          cx="674.1085"
          cy="1119.303"
          r="1.0000045"
          gradientTransform="matrix(-321.801 0 0 321.801 217170.375 -359951.34)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#6D28FF" />
          <stop offset="1" stopColor="#F7A7F9" />
        </radialGradient>
        <radialGradient
          id="skyGradient10"
          cx="658.4449"
          cy="1111.5979"
          r="1.0000042"
          gradientTransform="matrix(0 -247.1404 -247.1404 0 274962.53 162969.97)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#A273FF" />
          <stop offset="0.5" stopColor="#9FAEFF" />
          <stop offset="1" stopColor="#AAF2E1" />
        </radialGradient>
        <radialGradient
          id="skyGradient11"
          cx="-896.9763"
          cy="282.1837"
          r="1.0002127"
          gradientTransform="matrix(0 247.3404 -247.3404 0 70036.98 222100.12)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.0002" stopColor="#FFCD6B" />
          <stop offset="1" stopColor="#EB5EDF" />
        </radialGradient>
        <radialGradient
          id="skyGradient12"
          cx="665.0922"
          cy="1121.1327"
          r="1.0000044"
          gradientTransform="matrix(-183.9665 -158.8444 -158.8444 183.9665 300681.375 -100363.68)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#A273FF" />
          <stop offset="1" stopColor="#4331E9" />
        </radialGradient>
        <radialGradient
          id="skyGradient13"
          cx="674.7349"
          cy="1122.4294"
          r="1.0000046"
          gradientTransform="matrix(-247.559 0 0 247.559 167278.31 -277626.12)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FFF3D0" />
          <stop offset="1" stopColor="#FFC044" />
        </radialGradient>
        <radialGradient
          id="skyGradient14"
          cx="241.5421"
          cy="2191.5349"
          r="244.5967"
          gradientTransform="matrix(1 0 0 1 0 -1950)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#A273FF" />
          <stop offset="1" stopColor="#4331E9" />
        </radialGradient>
      </defs>
      <g>
        <path
          fill="url(#skyGradient1)"
          d="M46.1 99.6c7.5-10.2 15.7-19.9 24.6-28.8l3 1.7 166.3 167.1 1.6 2L46.1 99.6z"
        />
        <path
          fill="url(#skyGradient2)"
          d="M70.8 70.8c36-36.1 82.6-59.8 133-67.8l1.7 4.6 36.1 230.8v3.2L70.8 70.8z"
        />
        <path
          fill="url(#skyGradient3)"
          d="M351.3 26.4c11.3 5.7 22.1 12.3 32.3 19.8l-.4 3.8L242.5 240.9l-.9.7L351.3 26.4z"
        />
        <path
          fill="url(#skyGradient4)"
          d="M483.2 241.6c0 25.4-4 50.5-11.8 74.7l-5.7.9-222.3-74.7-1.8-.9h241.6z"
        />
        <path
          fill="url(#skyGradient5)"
          d="M471.4 316.3c-7.8 24.1-19.4 46.8-34.3 67.3l-5.5-.9L242.7 242.8l-1.1-1.2 235.3 74.7z"
        />
        <path
          fill="url(#skyGradient6)"
          d="M316.3 471.4c-36.2 11.8-74.8 14.8-112.5 8.8l-1.5-4.6 38.2-229.9 1.1-4.1 74.7 229.4z"
        />
        <path
          fill="url(#skyGradient7)"
          d="M203.8 480.2c-12.5-2-24.8-4.9-36.9-8.8l-.6-5.6 73.9-221.7 1.4-2.5-37.8 228.4z"
        />
        <path
          fill="url(#skyGradient8)"
          d="M166.9 471.4c-24.1-7.8-46.8-19.4-67.3-34.3v-4.4l139.5-188.6 2.5-2.5-74.7 229.4z"
        />
        <path
          fill="url(#skyGradient9)"
          d="M26.3 351.3C9 317.3 0 279.7 0 241.6l3.1-1.1h230.7l7.8 1.1L26.3 351.3z"
        />
        <path
          fill="url(#skyGradient10)"
          d="M203.8 3c37.6-6 76.2-2.9 112.4 8.8L241.6 241.6 203.8 3z"
        />
        <path
          fill="url(#skyGradient11)"
          d="M383.6 46.1c41.3 30 72 72.3 87.8 120.8L241.6 241.6l142-195.5z"
        />
        <path
          fill="url(#skyGradient12)"
          d="M99.6 437.1c-20.5-14.9-38.5-32.9-53.4-53.4L241.6 241.6 99.6 437.1z"
        />
        <path
          fill="url(#skyGradient13)"
          d="M0 241.6c0-25.4 4-50.5 11.8-74.7l229.8 74.7H0z"
        />
        <path
          fill="url(#skyGradient14)"
          d="M437.1 383.6c-14.9 20.5-32.9 38.5-53.4 53.5L241.6 241.6l195.5 142z"
        />
      </g>
    </Svg>
  );
}
